import { render, staticRenderFns } from "./RequestChangePassword.vue?vue&type=template&id=0ab4a4b4&scoped=true&"
import script from "./RequestChangePassword.vue?vue&type=script&lang=js&"
export * from "./RequestChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4a4b4",
  null
  
)

export default component.exports